'use strict';

var DowGroupFactory = function DowGroupFactory(DowConstants) {
  var daysOrder = {
    'sun': 1,
    'mon': 2,
    'tue': 3,
    'wed': 4,
    'thu': 5,
    'fri': 6,
    'sat': 7
  };
  function DowGroup(dowGroup) {
    dowGroup = dowGroup || {};
    /**
     * A list of string values like returned by rm-day-of-week: 'sun', 'mon', 'tue', ...
     * @type {Array.String}
     */
    this.days = dowGroup.days || []; // eg. ["mon", "sun"]
    this.disabledDays = dowGroup.disabledDays || [];
  }
  DowGroup.prototype.getName = function () {
    var map = DowConstants.ID_TO_NAME;
    if (!this.days) {
      return '-';
    } else if (this.days.length === 7) {
      return 'All';
    } else {
      return this.days.sort(function (a, b) {
        return daysOrder[a] - daysOrder[b];
      }).reduce(function (result, dow) {
        return result ? result + '_' + map[dow] : map[dow];
      }, '');
    }
  };
  return DowGroup;
};
DowGroupFactory.$inject = ['DowConstants'];
module.exports = DowGroupFactory;